import 'maps/js/maps';

const settings = {
	map: '.map--directions',
	postcode: '.map-input__postcode',
	directionsButton: '.map-input__button'
}

const initMaps = () => {
	const $map = $(settings.map);

	if ($map.length) {
		$map.maps({
			marker: true,
			zoomLevel: 9,
			streetViewControl: true,
			scrollwheel: false,
			directions: true,
			directionsStart: $(settings.postcode),
			directionsButton: $(settings.directionsButton),
			directionsRouteID: 'map-route'
		});
	}
}

initMaps();
